import { ApiBaseUrl } from "../config";
import { ResponseModel } from "../models/apiModels";
import { CategoryLookupModel } from "../store/features/categorySlice";

export async function getCategoryLookup(input: string) {
  if (!input) {
    return [];
  }

  const newUrl = new URL(`${ApiBaseUrl}/category`);
  newUrl.searchParams.append("searchTerm", input);
  newUrl.searchParams.append("pageSize", "20");
  newUrl.searchParams.append("pageNumber", "0");

  const response = await fetch(newUrl.href);

  const responseJson: ResponseModel<CategoryLookupModel[]> =
    await response.json();

  return responseJson.result || [];
}
